(() => {
  const root = window.Shopify?.routes?.root || '/';
  const route = (path) => `${root}${path.replace(/^\//, '')}`;
  const currency = window.Shopify?.currency?.active || 'INR';
  const money = (cents) => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0
  }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#039;',
    '"': '&quot;'
  })[character]);

  const focus = document.querySelector('[data-pp-focus]');
  if (focus) {
    const slides = [...focus.querySelectorAll('[data-slide]')];
    const tabs = [...focus.querySelectorAll('[data-tab]')];
    let index = 0;
    let timer;
    const select = (next) => {
      index = Number(next);
      slides.forEach((slide, itemIndex) => {
        const active = itemIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      tabs.forEach((tab, itemIndex) => {
        const active = itemIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
    };
    const play = () => {
      clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(() => select((index + 1) % slides.length), 5000);
      }
    };
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      select(tab.dataset.tab);
      play();
    }));
    focus.addEventListener('mouseenter', () => clearInterval(timer));
    focus.addEventListener('mouseleave', play);
    focus.addEventListener('focusin', () => clearInterval(timer));
    focus.addEventListener('focusout', play);
    select(0);
    play();
  }

  const productPage = document.querySelector('[data-pp-product-page]');
  if (productPage) {
    const form = productPage.querySelector('[data-pp-product-form]');
    const mainImage = productPage.querySelector('[data-pp-main-image]');
    const mainAdd = form?.querySelector('[data-pp-add]');
    const price = productPage.querySelector('[data-pp-price]');
    const compare = productPage.querySelector('[data-pp-compare]');
    const saving = productPage.querySelector('[data-pp-saving]');
    const sticky = productPage.querySelector('[data-pp-product-sticky]');
    const stickyPrice = sticky?.querySelector('[data-pp-sticky-price]');
    const stickyVariant = sticky?.querySelector('[data-pp-sticky-variant]');
    const stickyAdd = sticky?.querySelector('[data-pp-sticky-add]');

    productPage.querySelectorAll('[data-pp-media-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.mediaSrc;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.mediaAlt || '';
        productPage.querySelectorAll('[data-pp-media-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });

    productPage.querySelectorAll('[data-pp-variant]').forEach((variant) => {
      variant.addEventListener('change', () => {
        if (!variant.checked && variant.type !== 'hidden') return;
        if (price) price.textContent = variant.dataset.price || '';
        if (stickyPrice) stickyPrice.textContent = variant.dataset.price || '';
        if (stickyVariant) stickyVariant.textContent = variant.dataset.variantTitle || '';
        if (compare) {
          compare.textContent = variant.dataset.compare || '';
          compare.hidden = !variant.dataset.compare;
        }
        if (saving) {
          saving.textContent = variant.dataset.saving || '';
          saving.hidden = !variant.dataset.saving;
        }
        const unavailable = variant.disabled;
        if (mainAdd) mainAdd.disabled = unavailable;
        if (stickyAdd) stickyAdd.disabled = unavailable;
      });
    });

    stickyAdd?.addEventListener('click', () => mainAdd?.click());
    if (mainAdd && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }, { threshold: 0.2 });
      observer.observe(mainAdd);
    }
  }

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-pp-qty-minus]');
    const plus = event.target.closest('[data-pp-qty-plus]');
    if (!minus && !plus) return;
    const input = event.target.closest('.pp-qty')?.querySelector('input');
    if (!input) return;
    const current = Math.max(1, Number(input.value) || 1);
    input.value = plus ? current + 1 : Math.max(1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const drawer = document.querySelector('[data-pp-cart-drawer]');
  const scrim = document.querySelector('[data-pp-cart-scrim]');
  const lines = drawer?.querySelector('[data-pp-cart-lines]');
  const foot = drawer?.querySelector('[data-pp-cart-foot]');
  const total = drawer?.querySelector('[data-pp-cart-total]');
  const status = drawer?.querySelector('[data-pp-cart-status]');
  const shipping = drawer?.querySelector('[data-pp-shipping-progress]');
  const shippingCopy = drawer?.querySelector('[data-pp-shipping-copy]');
  const shippingBar = drawer?.querySelector('[data-pp-shipping-bar]');
  const threshold = Number(drawer?.dataset.freeShippingThreshold || 0);
  let lastFocused;

  const renderCart = (cart) => {
    document.querySelectorAll('[data-pp-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    if (!drawer || !lines || !foot || !total) return;
    total.textContent = money(cart.total_price);
    foot.hidden = cart.item_count === 0;
    if (cart.item_count === 0) {
      lines.innerHTML = '<div class="pp-cart-empty"><strong>Your pantry has room.</strong><p>Start with one familiar flour or choose a better-value combo.</p><a class="pp-button pp-button-lime" href="/collections/all">Shop PurePind</a></div>';
      return;
    }
    lines.innerHTML = cart.items.map((item) => `
      <article class="pp-cart-drawer-line">
        <a class="pp-cart-drawer-image" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" width="92" height="110" alt="${escapeHtml(item.product_title)}">` : ''}${item.product_type === 'PurePind Combo' ? '<em>COMBO</em>' : ''}</a>
        <div>
          <a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHtml(item.variant_title)}</span>` : ''}
          <div class="pp-cart-line-actions">
            <button type="button" data-pp-line-change data-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <b>${item.quantity}</b>
            <button type="button" data-pp-line-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            <button type="button" data-pp-line-change data-key="${escapeHtml(item.key)}" data-quantity="0">Remove</button>
          </div>
        </div>
        <strong>${money(item.final_line_price)}</strong>
      </article>`).join('');

    if (shipping && shippingCopy && shippingBar && threshold > 0) {
      shipping.hidden = false;
      const remaining = Math.max(0, threshold - cart.total_price);
      shippingCopy.textContent = remaining > 0
        ? `Add ${money(remaining)} more for FREE shipping · ₹79 shipping below ₹799`
        : 'FREE shipping unlocked for this order';
      shippingBar.style.width = `${Math.min(100, (cart.total_price / threshold) * 100)}%`;
    } else if (shipping) {
      shipping.hidden = true;
    }
  };

  const refreshCart = async () => {
    const response = await fetch(route('/cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Your bag could not be refreshed.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const openCart = async () => {
    if (!drawer || !scrim) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.hidden = false;
    requestAnimationFrame(() => scrim.classList.add('is-open'));
    document.documentElement.classList.add('pp-cart-open');
    drawer.querySelector('[data-pp-cart-close]')?.focus();
    try {
      if (status) status.textContent = '';
      await refreshCart();
    } catch (error) {
      if (status) status.textContent = error.message;
    }
  };

  const closeCart = () => {
    if (!drawer || !scrim) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-open');
    window.setTimeout(() => { scrim.hidden = true; }, 220);
    document.documentElement.classList.remove('pp-cart-open');
    lastFocused?.focus?.();
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-pp-cart-open]');
    if (opener) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-pp-cart-close]') || event.target === scrim) {
      closeCart();
      return;
    }
    const change = event.target.closest('[data-pp-line-change]');
    if (!change) return;
    change.disabled = true;
    try {
      const response = await fetch(route('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: change.dataset.key, quantity: Number(change.dataset.quantity) })
      });
      if (!response.ok) throw new Error('That quantity could not be updated.');
      renderCart(await response.json());
      if (status) status.textContent = '';
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      change.disabled = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeCart();
  });

  document.addEventListener('submit', async (event) => {
    const addButton = event.submitter?.closest?.('[data-pp-add]');
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!addButton || !form) return;
    event.preventDefault();
    addButton.disabled = true;
    const original = addButton.textContent;
    addButton.textContent = 'Adding…';
    try {
      const response = await fetch(route('/cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || 'This item could not be added.');
      }
      await openCart();
    } catch (error) {
      if (drawer) await openCart();
      if (status) status.textContent = error.message;
    } finally {
      addButton.disabled = false;
      addButton.textContent = original;
    }
  });
})();

